import React from "react";

/**
 * On/off toggle. Controlled component; parent supplies `on` and `onChange`.
 * @param {Object} props
 * @param {boolean} props.on
 * @param {(next:boolean)=>void} props.onChange
 * @param {string} [props.ariaLabel]
 */
export function Toggle({ on, onChange, ariaLabel }) {
  return (
    <button
      type="button"
      className={`ds-toggle ${on ? "is-on" : ""}`.trim()}
      aria-pressed={on}
      aria-label={ariaLabel}
      onClick={() => onChange(!on)}
    >
      <span className="ds-toggle-dot" />
    </button>
  );
}
